var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainTest"}},[_vm._v("\n  this is test page in work "+_vm._s(_vm.cnt)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }